export default __webpack_public_path__ + "static/media/logo.ff1a73f3.png";